import { toast } from 'react-toastify'

import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'

import { displayMessages } from './common'

export function getAprobaciones(page = 1) {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().externosaprobaciones.get('showRecords')
		const orderBy = getState().externosaprobaciones.get('orderBy')
		const filters = getState().externosaprobaciones.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()
		const having = []

		axios.get(`${API_URL}/externos/documentos`, { params: { estado: 1, page, showRecords, orderBy, filters, having }})
		.then((res) => {
			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_EXTERNOS_APROBACIONES, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})

	}
}

export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES, payload: showRecords })
        const fn1 = (d) => d(getAprobaciones(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function filterAprobaciones(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_EXTERNOS_APROBACIONES, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().externosaprobaciones.get('orderBy')
		current = current.set('field', field.value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_EXTERNOS_APROBACIONES, payload: { orderBy: current } })
        const fn1 = (d) => d(getAprobaciones(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function showHideModalFilter(state, tableCols) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES, payload: { state, tableCols} })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES })
        const fn1= (d) => d(getAprobaciones(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function showHideModalSummary(show, id) {
	const axios = createAxiosInstance()

    return (dispatch) => {
		axios.get(`${API_URL}/externos/documentos`, { params: { id }})
		.then((res) => {
			const fn1 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES, payload: { show, data: res.data }})
			fn1(dispatch)
		})
		.catch((err) => {
            console.log(err)
			displayMessages(dispatch, err)
		})
    }
}

export function registerApprovalResult(id, result) {
	const ip = require('ip');
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const data = getState().externosaprobaciones.getIn(['modalSummary', 'data']).set('result', result)

		const errors = validateDocumento(data)
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = [{
				id: id,
				entity: 'ProveedorAprobacione',
				value: { estado: result, ip: ip.address(), observaciones: data.get('observaciones') },
				action: 'replace'
			}]


			axios.put(`${API_URL}/externos/documentos/${id}`, modificaciones)
				.then(res => {
					const fn0 = (d) => d(getAprobaciones(1))
					fn0(dispatch)
					displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
			})

		}
	}
}


export function updateInputs(path, value) {
	return (dispatch) => {
        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_EXTERNOS_APROBACIONES, payload: { path, value } })
        fn0(dispatch)
	}
}


///******* Shared ********///


const validateDocumento = (data) => {
	const errors = []
	if (!data.get('observaciones') && data.get('result') == 1) errors.push('Debe agregar una observación si va a regresar el documento')
	return errors
}


// WEBPACK FOOTER //
// ./src/actions/externosaprobaciones.js